import React from 'react';

const LoginFooter = () => {
  const currentYear = new Date()?.getFullYear();

  return (
    <div className="mt-8 md:mt-12 text-center space-y-4">
      <div className="flex items-center justify-center gap-6 text-xs md:text-sm text-muted-foreground">
        <a
          href="#"
          className="hover:text-foreground transition-smooth"
        >
          Privacy Policy
        </a>
        <span className="text-border">|</span>
        <a
          href="#"
          className="hover:text-foreground transition-smooth"
        >
          Terms of Service
        </a>
        <span className="text-border">|</span>
        <a
          href="#"
          className="hover:text-foreground transition-smooth"
        >
          Support
        </a>
      </div>
      <p className="text-xs text-muted-foreground">
        &copy; {currentYear} eCity Pro. All rights reserved.
      </p>
    </div>
  );
};

export default LoginFooter;